export class DataTableResult {
    data?: any | undefined;
    recordsTotal?: number;
    recordsFiltered?: number;
    draw?: number;
    isSuccess?: boolean;

    static fromJS(data: any): DataTableResult {
        const result = new DataTableResult();
        result.data = data.data;
        result.recordsTotal = data.recordsTotal;
        result.recordsFiltered = data.recordsFiltered;
        result.draw = data.draw;
        result.isSuccess = data.isSuccess;
        return result;
    }
}
